import { useEffect } from 'react';
import useAsync from 'hooks/useAsync';
import { getObservationsCount } from 'actions/envScales/reports';
import { OptionalDate } from 'components/Reports/Observation/DateRangePicker';
import { buildObservationsCountParams } from 'components/Reports/Observation/observationCountParams';
import { FormValues } from 'pages/Reports/ObservationV2/Observation';

interface UseReportTotalProps {
  startDate: OptionalDate;
  endDate: OptionalDate;
  ageLevel: string | null;
  nodeIds: number[];
  includeArchivedClassrooms?: boolean;
  includeArchivedNodes?: boolean;
}

export function useReportTotal({
  endDate,
  startDate,
  ageLevel,
  nodeIds,
  includeArchivedClassrooms,
  includeArchivedNodes
}: UseReportTotalProps) {
  const { run, data, isPending } = useAsync();

  useEffect(() => {
    if (!startDate || !endDate) {
      return;
    }

    run(
      getObservationsCount(
        buildObservationsCountParams({
          startDate,
          endDate,
          ageLevel,
          nodeIds,
          includeArchivedClassrooms,
          includeArchivedNodes
        })
      )
    );
  }, [
    run,
    endDate,
    startDate,
    ageLevel,
    nodeIds,
    includeArchivedClassrooms,
    includeArchivedNodes
  ]);

  return {
    total: data?.total_observations ?? null,
    isLoading: isPending
  };
}
export function resolveIncludeArchivedNodes(values: FormValues): boolean {
  return values.includeArchivedNodes ?? true;
}

export function resolveIncludeArchivedClassrooms(values: FormValues): boolean {
  return values.includeArchivedClassrooms ?? true;
}
